import { useRef, useState } from 'react';

const useLocalStorage = (key, initialValue, silent = false) => {
  //hasKey
  const hasKey = useRef(true);
  const _value = useRef(true);

  function get_initial_state() {
      try {
        // Get from local storage by key
        const item = JSON.parse(window.localStorage.getItem(key));
        if(!item) hasKey.current = false
        else hasKey.current = true;
        // Parse stored json or if none return initialValue
        const result = item ? item : initialValue;
        _value.current = result;
        return result;
      } catch (error) {
        // If error also return initialValue
        console.log(error);
        return initialValue;
      }
  }
  // State to store our value
  // Pass initial state function to useState so logic is only executed once
  const [storedValue, setStoredValue] = useState(() => get_initial_state());

  // Return a wrapped version of useState's setter function that ...
  // ... persists the new value to localStorage.
  const setValue = value => {
    try {
      // Allow value to be a function so we have same API as useState
      const valueToStore = value instanceof Function ? value(storedValue) : value;
      // Save state only if needed
      if (!silent) setStoredValue(valueToStore);
      _value.current = valueToStore;
      // Save to local storage
      window.localStorage.setItem(key, JSON.stringify(valueToStore));
      hasKey.current = true;
    } catch (error) {
      // A more advanced implementation would handle the error case
      console.log(error);
    }
  };

  return [_value.current, setValue, hasKey?.current];
};

export default useLocalStorage;
